import React, { memo, useCallback, useState } from 'react';
import { Col, Input, Modal, Row, Spin } from 'antd';
import { useQuery } from 'react-query';

import DF from '../../DisplayFramework';
import {
  AssetCatalogResponse,
  getAssetCatalogByKeyword,
  ParAssetCatalogOptionResponse,
  ParAssetCatalogServiceResponse,
} from '../../services/assetconfig';
import useDebounce from '../../hooks/useDebounce';
import GetLabel from 'DisplayFramework/components/GetLabel';
import AssetCatalogItem from './AssetCatalogItem';

export type AssetCatalogModalProps = {
  visible: boolean;
  onCancel: () => void;
  onSelect: (
    item: AssetCatalogResponse,
    nbasset: number,
    selectedServices?: ParAssetCatalogServiceResponse[],
    selectedOption?: ParAssetCatalogOptionResponse[],
    fromCatalogMulticomponents?: boolean,
    assetCatalogServices?: ParAssetCatalogServiceResponse[],
    assetCatalogOptions?: ParAssetCatalogOptionResponse[]
  ) => void;
  currcode?: string;
  network?: string;
  flagwebshop?: boolean;
};

const AssetCatalogModal = (props: AssetCatalogModalProps) => {
  const { visible, onCancel, onSelect, currcode, network, flagwebshop } = props;

  const [assetkeyword, setAssetkeyword] = useState('');

  const debouncedAssetKeyword = useDebounce(assetkeyword);

  const { data: assetsCatalog ,isFetching} = useQuery(
    ['getAssetCatalogByKeyword', { debouncedAssetKeyword }],
    () =>
      getAssetCatalogByKeyword({
        keyword: debouncedAssetKeyword,
        filters: '',
        mcid: '',
        mgid: '',
        networkcode: network,
        tpidbroker: '',
        currcode: currcode ?? localStorage.getItem('currcode'),
        flagwebshop: flagwebshop ?? false,
      } as any).then((res) => res.list || []),
    {
      enabled: debouncedAssetKeyword.length > 2,
      staleTime: 30 * 1000,
    }
  );

  const clearAndCancel = useCallback(() => {
    setAssetkeyword('');
    onCancel();
  }, [onCancel, setAssetkeyword]);

  const handleSelect = useCallback(
    (
      item,
      nbasset,
      selectedServices,
      selectedOption,
      fromCatalogMulticomponents,
      assetCatalogServices,
      assetCatalogOptions
    ) => {
      setAssetkeyword('');
      onSelect(
        item,
        nbasset,
        selectedServices,
        selectedOption,
        fromCatalogMulticomponents,
        assetCatalogServices,
        assetCatalogOptions
      );
    },
    [onSelect]
  );

  return (
    (<Modal
      open={visible}
      title={<GetLabel label="assetcatalog" Inspectstyle={{ width: '30%' }} />}
      footer={null}
      onCancel={clearAndCancel}
      width={1200}
    >
      <DF.Input comcode="assetkeyword">
        <Input
          onChange={(event) => setAssetkeyword(event.target.value)}
          value={assetkeyword}
        />
      </DF.Input>
      <Row gutter={10}>
      <Col span={24}> <Spin spinning={isFetching} style={{margin:'0% 50%'}}/></Col>
      
        {assetsCatalog?.map((item, index) => (
          <Col key={index} lg={8} style={{ marginBottom: 10 }}>
            <AssetCatalogItem item={item} onSelect={handleSelect} />
          </Col>
        ))}
      </Row>
    </Modal>)
  );
};

export default memo(AssetCatalogModal);
